import { __extends } from "tslib";
import { deserializeAws_restXmlPutBucketInventoryConfigurationCommand, serializeAws_restXmlPutBucketInventoryConfigurationCommand } from "../protocols/Aws_restXml";
import { getBucketEndpointPlugin } from "@aws-sdk/middleware-bucket-endpoint";
import { getSerdePlugin } from "@aws-sdk/middleware-serde";
import { Command as $Command } from "@aws-sdk/smithy-client";
var PutBucketInventoryConfigurationCommand = /** @class */ (function (_super) {
    __extends(PutBucketInventoryConfigurationCommand, _super);
    // Start section: command_properties
    // End section: command_properties
    function PutBucketInventoryConfigurationCommand(input) {
        var _this = 
        // Start section: command_constructor
        _super.call(this) || this;
        _this.input = input;
        return _this;
        // End section: command_constructor
    }
    PutBucketInventoryConfigurationCommand.prototype.resolveMiddleware = function (clientStack, configuration, options) {
        this.middlewareStack.use(getSerdePlugin(configuration, this.serialize, this.deserialize));
        this.middlewareStack.use(getBucketEndpointPlugin(configuration));
        var stack = clientStack.concat(this.middlewareStack);
        var handlerExecutionContext = {
            logger: {}
        };
        var requestHandler = configuration.requestHandler;
        return stack.resolve(function (request) {
            return requestHandler.handle(request.request, options || {});
        }, handlerExecutionContext);
    };
    PutBucketInventoryConfigurationCommand.prototype.serialize = function (input, context) {
        return serializeAws_restXmlPutBucketInventoryConfigurationCommand(input, context);
    };
    PutBucketInventoryConfigurationCommand.prototype.deserialize = function (output, context) {
        return deserializeAws_restXmlPutBucketInventoryConfigurationCommand(output, context);
    };
    return PutBucketInventoryConfigurationCommand;
}($Command));
export { PutBucketInventoryConfigurationCommand };
//# sourceMappingURL=PutBucketInventoryConfigurationCommand.js.map